
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-storage-price",
      function () {
        return require("private-next-pages/college-storage-price/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-storage-price"])
      });
    }
  